/**
 * Deterministyczny generator liczb losowych (mulberry32).
 * Stan żyje w GameState, więc ta sama gra z tym samym seedem i wejściem zawsze przebiega identycznie.
 * W silniku NIE używamy Math.random().
 */
export function nextRandom(holder: { rng: number }): number {
  let t = (holder.rng = (holder.rng + 0x6d2b79f5) | 0);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
}
